import {DatePipe, SlicePipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {MatDialog} from '@angular/material/dialog'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatInput} from '@angular/material/input'
import {MatSort, MatSortHeader} from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table'
import {startWith} from 'rxjs'
import {IdListDialogComponent} from '../common/id-list-dialog/id-list-dialog.component'
import {DataService} from '../services/data.service'
import '@angular/common/locales/global/fr'
import {BaseTable} from '@sparbanken-syd/sparbanken-syd-theme'
import {IBankIDVerificationItem, IListItem} from '../0-application/types'

@Component({
  selector: 'spb-id-list',
  templateUrl: './id-list.component.html',
  styleUrls: ['./id-list.component.scss'],
  imports: [
    SlicePipe,
    MatTable,
    ReactiveFormsModule,
    MatFormField,
    DatePipe,
    MatColumnDef,
    MatHeaderCell,
    MatSort,
    MatInput,
    MatCell,
    MatNoDataRow,
    MatRow,
    MatHeaderRow,
    MatLabel,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatSortHeader
  ]
})
export class IdListComponent extends BaseTable<IListItem> implements OnInit {

  public filterControl = new FormControl<string>('', {nonNullable: true})

  public dataSource = new MatTableDataSource<IListItem>()

  private readonly dataService = inject(DataService)
  private readonly dialog = inject(MatDialog)

  constructor() {
    super()
    this.columns.set(['timeStamp', 'personalNumber', 'name'])
  }

  public ngOnInit(): void {
    /**
     * Get all verifications (succeeded and errors) from database and set them to a signals list
     */
    this.dataService.getMyTransactions()
      .subscribe(items => {
        this.dataSource.data = items.toSorted((a, b) => b.timeStamp - a.timeStamp)
          .map(item => {
            return {
              ...item,
              name: item.user?.name,
              personalNumber: item.user?.personalNumber
            }
          })
      })

    /**
     * Controls the filter input field, replace is for sub
     */
    this.filterControl.valueChanges.pipe(
      startWith('')
    ).subscribe(value =>
      this.dataSource.filter = value.trim().toLowerCase().replace('-', '')
    )
  }

  public openDialog(bid: IBankIDVerificationItem) {
    this.dataService.userData.set({...bid, title: 'Detaljer'})
    this.dialog.open(IdListDialogComponent)
  }
}
